import { Tooltip } from "antd";
import { TickCircle } from "iconsax-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  changeStep,
  setActiveStep,
  setCurrentIndex,
} from "../../state/features/stepSlice";

export const CSteps = (steps: any) => {
  const dispatch = useDispatch();
  const current_index = steps?.steps?.list?.findIndex(
    (element: any) => element.step_id === steps.steps.current
  );

  const [selected, setSelected] = useState<number>(current_index);

  const active_index =
    steps?.steps?.parallel_steps?.length > 0
      ? steps?.steps?.parallel_steps[0]?.step_list?.split(",")?.map(Number)
      : [];

  useEffect(() => {
    dispatch(changeStep(current_index));
    dispatch(setCurrentIndex(current_index));
    dispatch(setActiveStep(active_index));
  }, [current_index]);

  const width = 20;

  const calculatedWidth = `w-[${width}%]`;

  return (
    steps?.steps?.list && (
      <div className="flex items-center w-full">
        {steps?.steps?.list.map((step: any, index: number) => {
          if (index < current_index)
            return (
              <div
                key={index}
                className={`flex items-center ${calculatedWidth}`}
              >
                <Tooltip
                  placement="bottom"
                  title={<span>{step.step_name}</span>}
                  color="#1890FF"
                >
                  <TickCircle
                    className="mx-2 cursor-pointer"
                    size="40"
                    color="#1890FF"
                    onClick={() => {
                      if (!steps.steps.disabled) {
                        setSelected(index);
                        dispatch(changeStep(index));
                      }
                    }}
                  />
                </Tooltip>
                <div className=" bg-step_color h-[1px] w-full"></div>
              </div>
            );
          if (index == current_index) {
            if (index == steps?.steps?.list.length - 1) {
              return (
                <div
                  key={index}
                  className={`flex items-center ${
                    index + 1 == steps.steps.list.length ? "" : calculatedWidth
                  }`}
                >
                  <Tooltip
                    placement="bottom"
                    title={<span>{step.step_name}</span>}
                    color="#1890FF"
                  >
                    <div
                      className={` bg-step_color text-white text-[8px] xsm:text-[12px] mx-2 flex items-center justify-center rounded-[50%] text-step_grey border-[1px] border-step_grey cursor-pointer w-4 h-4 xsm:w-5 xsm:h-5 md:h-7 md:w-7 p-1 xsm:p-2 `}
                      key={index}
                      onClick={() => {
                        if (!steps.steps.disabled) {
                          setSelected(index);
                          dispatch(changeStep(index));
                        }
                      }}
                    >
                      {index + 1}
                    </div>
                  </Tooltip>
                </div>
              );
            }

            return (
              <div
                key={index}
                className={`flex items-center ${calculatedWidth}`}
              >
                <Tooltip
                  placement="bottom"
                  title={<span>{step.step_name}</span>}
                  color="#1890FF"
                >
                  <div
                    className={` ${
                      selected == current_index ||
                      !active_index?.includes(selected + 1)
                        ? "bg-step_color text-white"
                        : " bg-white text-black border-black border-[1px]"
                    } text-[8px] xsm:text-[12px] mx-2 flex items-center justify-center w-4 h-4  xsm:w-5 xsm:h-5 md:h-7 md:w-7 p-1 xsm:p-2 rounded-[50%] cursor-pointer`}
                    key={index}
                    onClick={() => {
                      if (!steps.steps.disabled) {
                        setSelected(index);
                        dispatch(changeStep(index));
                      }
                    }}
                  >
                    {index + 1}
                  </div>
                </Tooltip>

                <div className=" w-full bg-step_grey h-[1px]"></div>
              </div>
            );
          }
          if (index > current_index && active_index?.includes(index + 1))
            return (
              <div
                key={index}
                className={`flex items-center ${
                  index + 1 == steps.steps.list.length ? "" : calculatedWidth
                }`}
              >
                <Tooltip
                  placement="bottom"
                  title={<span>{step.step_name}</span>}
                >
                  <div
                    className={` ${
                      selected === index
                        ? "bg-step_color text-white"
                        : active_index?.includes(current_index + 1)
                        ? steps?.steps?.list[index]["eval_status"] === "Pending"
                          ? "text-black border-black"
                          : " text-step_color border-step_color"
                        : "text-step_grey bg-[#E4E4E4] border-step_grey"
                    } text-[8px] xsm:text-[12px] mx-2 flex items-center justify-center rounded-[50%]  border-[1px]  cursor-pointer w-4 h-4  xsm:w-5 xsm:h-5 md:h-7 md:w-7 p-1 xsm:p-2 `}
                    key={index}
                    onClick={() => {
                      if (
                        !steps.steps.disabled &&
                        active_index?.includes(current_index + 1) &&
                        steps?.steps?.list[index]["eval_status"] === "Pending"
                      ) {
                        setSelected(index);
                        dispatch(changeStep(index));
                      }
                    }}
                  >
                    {index + 1}
                  </div>
                </Tooltip>

                <div
                  className={`${
                    index + 1 == steps.steps.list.length
                      ? " hidden"
                      : " bg-step_grey w-full h-[1px]"
                  }`}
                ></div>
              </div>
            );
          if (index > current_index && !active_index?.includes(index + 1))
            return (
              <div
                key={index}
                className={`flex items-center ${
                  index + 1 == steps.steps.list.length ? "" : calculatedWidth
                }`}
              >
                <Tooltip
                  placement="bottom"
                  title={<span>{step.step_name}</span>}
                >
                  <div
                    className={` text-[8px] xsm:text-[12px] mx-2 flex items-center justify-center rounded-[50%] text-step_grey border-[1px] bg-[#E4E4E4] border-step_grey cursor-pointer w-4 h-4  xsm:w-5 xsm:h-5 md:h-7 md:w-7 p-1 xsm:p-2 `}
                    key={index}
                    onClick={() => {
                      if (!steps.steps.disabled) {
                        setSelected(index);
                        dispatch(changeStep(index));
                      }
                    }}
                  >
                    {index + 1}
                  </div>
                </Tooltip>

                <div
                  className={`${
                    index + 1 == steps.steps.list.length
                      ? " hidden"
                      : " bg-step_grey w-full h-[1px]"
                  }`}
                ></div>
              </div>
            );
        })}
      </div>
    )
  );
};
